export default __webpack_public_path__ + "static/media/family-at-park.9b13f5e9.svg";